import { API_BASE } from './apiBase';

const deriveApiOrigin = () => {
  const base = (API_BASE || '').trim();
  if (base) {
    try {
      const parsed = new URL(base, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
      if (parsed.pathname.endsWith('/api')) {
        parsed.pathname = parsed.pathname.replace(/\/api$/, '');
      }
      return `${parsed.origin}${parsed.pathname.replace(/\/$/, '')}`;
    } catch (_) {
      if (base.endsWith('/api')) return base.replace(/\/api$/, '');
      return base;
    }
  }
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost') {
      return `${window.location.protocol}//${window.location.hostname}:5001`;
    }
    return window.location.origin;
  }
  return '';
};

const API_ORIGIN = deriveApiOrigin();

export const resolveAssetUrl = (url) => {
  if (!url) return '';
  if (/^https?:/i.test(url)) {
    const idx = url.indexOf('/uploads/');
    if (idx >= 0) {
      const path = url.slice(idx);
      return `${API_ORIGIN}${path}`;
    }
    return url;
  }
  const normalized = url.startsWith('/') ? url : `/${url}`;
  return `${API_ORIGIN}${normalized}`;
};
